import React, { useEffect, useState } from 'react';
import {XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Bar, ComposedChart, Area, BarChart, Line } from 'recharts';
import * as d3 from 'd3';
import MultiSelectDropdown from '../multiselect/MultiSelectDropdown';

const colors = ["rgb(156,39,176)", "rgb(255,152,0)", "rgb(76,175,80)", "#ff7300", "#ff0000", "#0000ff"]; 
const StopeChart = ({stopeID}) => {
  const [data, setData] = useState([]);
  const [alldata, setAllData] = useState({});

  
  const [stopeData, setStopeData] = useState([[],'Month',[]]);

  const [summary_field, setSummaryField] = useState('Month');

  const [parsedData, setParsedData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('./files/Stoping_Data_2023_2025.csv');
        const csvText = await response.text();
        const parsedCsvData = d3.csvParse(csvText);
        setParsedData(parsedCsvData);
      } catch (error) {
        console.error('Error fetching CSV file:', error);
      }
    };

    fetchData();
  }, []);
  
  

  // stopeID = null
  useEffect(() => {     

    console.log("parsedData", parsedData)
      if(!parsedData) return

      console.log(parsedData)
      let filteredData = parsedData;
      if (stopeID) {
        filteredData = parsedData.filter(row => row['ID'] === stopeID);
      }

      if(stopeData[0].length>0){
        filteredData = filteredData.filter(row => stopeData[0].includes(row['Level']));
      }

      if(stopeData[2].length>0){
        filteredData = filteredData.filter(row => stopeData[2].includes(row[stopeData[1]]));
      }

      console.log(filteredData)

      // Add Month, Quarter, Year fields to each row like in BottomBar
      const processedData = filteredData.map(row => {
        const dateStr = row.Date;
        let date = null;
        
        if (dateStr) {
          const parts = dateStr.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            date = new Date(year, month, day);
          }
        }

        return {
          ...row,
          Month: date ? date.toLocaleString('default', { month: 'long' }) + ' ' + date.getFullYear() : '',
          Quarter: date ? `Q${Math.floor((date.getMonth() + 3) / 3)} ${date.getFullYear()}` : '',
          Year: date ? date.getFullYear().toString() : ''
        };
      });

      const summary = {};
      const totalSummary = {
        FY2025_Plan_Tonnage: 0,
        Planned_Tonnage: 0,
        Mined_Tonnage: 0,
        Tramming_Budget_Tonnage: 0,
        Tramming_Actual_Tonnage: 0,
        FY2025_Plan_Grade: 0,
        Planned_Grade: 0,
        Actual_Grade: 0,
        Tramming_Budget_Grade: 0,
        Tramming_Actual_Grade: 0,
        FY2025_Plan_Content: 0,
        Planned_Content: 0,
        Actual_Content: 0,
        Tramming_Budget_Content: 0,
        Tramming_Actual_Content: 0,
        FY2025_Plan_Tonnage_Sum: 0,
        Planned_Tonnage_Sum: 0,
        Mined_Tonnage_Sum: 0,
        Tramming_Budget_Tonnage_Sum: 0,
        Tramming_Actual_Tonnage_Sum: 0
      };

      processedData.forEach(row => {
        const key = row[summary_field];
        if (!summary[key]) {
          summary[key] = {
            FY2025_Plan_Tonnage: 0,
            Planned_Tonnage: 0,
            Mined_Tonnage: 0,
            Tramming_Budget_Tonnage: 0,
            Tramming_Actual_Tonnage: 0,
            FY2025_Plan_Grade: 0,
            Planned_Grade: 0,
            Actual_Grade: 0,
            Tramming_Budget_Grade: 0,
            Tramming_Actual_Grade: 0,
            FY2025_Plan_Content: 0,
            Planned_Content: 0,
            Actual_Content: 0,
            Tramming_Budget_Content: 0,
            Tramming_Actual_Content: 0,
            FY2025_Plan_Tonnage_Sum: 0,
            Planned_Tonnage_Sum: 0,
            Mined_Tonnage_Sum: 0,
            Tramming_Budget_Tonnage_Sum: 0,
            Tramming_Actual_Tonnage_Sum: 0
          };
        }
        
        // FY2025 Plan data
        const fy2025Tonnage = parseFloat(row['FY2025_Breaking_Plan_t']) || 0;
        const fy2025Grade = parseFloat(row['FY2025_Breaking_Plan_gpt']) || 0;
        const fy2025Kgs = parseFloat(row['FY2025_Breaking_Plan_kgs']) || 0;
        
        // Budget (Planned) data
        const plannedTonnage = parseFloat(row['Stoping_Budget_t']) || 0;
        const plannedGrade = parseFloat(row['Stoping_Budget_gpt']) || 0;
        const plannedKgs = parseFloat(row['Stoping_Budget_kgs']) || 0;
        
        // Actual (Mined) data
        const actualTonnage = parseFloat(row['Stoping_Actual_t']) || 0;
        const actualGrade = parseFloat(row['Stoping_Actual_gpt']) || 0;
        const actualKgs = parseFloat(row['Stoping_Actual_kgs']) || 0;
        
        // Tramming Budget data
        const trammingBudgetTonnage = parseFloat(row['Tramming_Budget_t']) || 0;
        const trammingBudgetGrade = parseFloat(row['Tramming_Budget_gpt']) || 0;
        const trammingBudgetKgs = parseFloat(row['Tramming_Budget_kgs']) || 0;
        
        // Tramming Actual data
        const trammingActualTonnage = parseFloat(row['Tramming_Actual_t']) || 0;
        const trammingActualGrade = parseFloat(row['Tramming_Actual_gpt']) || 0;
        const trammingActualKgs = parseFloat(row['Tramming_Actual_kgs']) || 0;

        // Accumulate FY2025 Plan data
        summary[key].FY2025_Plan_Tonnage += fy2025Tonnage;
        summary[key].FY2025_Plan_Grade += fy2025Grade * fy2025Tonnage;
        summary[key].FY2025_Plan_Content += fy2025Kgs;
        summary[key].FY2025_Plan_Tonnage_Sum += fy2025Tonnage;

        // Accumulate Budget (Planned) data
        summary[key].Planned_Tonnage += plannedTonnage;
        summary[key].Planned_Grade += plannedGrade * plannedTonnage;
        summary[key].Planned_Content += plannedKgs;
        summary[key].Planned_Tonnage_Sum += plannedTonnage;

        // Accumulate Actual (Mined) data
        summary[key].Mined_Tonnage += actualTonnage;
        summary[key].Actual_Grade += actualGrade * actualTonnage;
        summary[key].Actual_Content += actualKgs;
        summary[key].Mined_Tonnage_Sum += actualTonnage;

        // Accumulate Tramming Budget data
        summary[key].Tramming_Budget_Tonnage += trammingBudgetTonnage;
        summary[key].Tramming_Budget_Grade += trammingBudgetGrade * trammingBudgetTonnage;
        summary[key].Tramming_Budget_Content += trammingBudgetKgs;
        summary[key].Tramming_Budget_Tonnage_Sum += trammingBudgetTonnage;

        // Accumulate Tramming Actual data
        summary[key].Tramming_Actual_Tonnage += trammingActualTonnage;
        summary[key].Tramming_Actual_Grade += trammingActualGrade * trammingActualTonnage;
        summary[key].Tramming_Actual_Content += trammingActualKgs;
        summary[key].Tramming_Actual_Tonnage_Sum += trammingActualTonnage;

        // Total summaries
        totalSummary.FY2025_Plan_Tonnage += fy2025Tonnage;
        totalSummary.FY2025_Plan_Grade += fy2025Grade * fy2025Tonnage;
        totalSummary.FY2025_Plan_Content += fy2025Kgs;
        totalSummary.FY2025_Plan_Tonnage_Sum += fy2025Tonnage;

        totalSummary.Planned_Tonnage += plannedTonnage;
        totalSummary.Planned_Grade += plannedGrade * plannedTonnage;
        totalSummary.Planned_Content += plannedKgs;
        totalSummary.Planned_Tonnage_Sum += plannedTonnage;

        totalSummary.Mined_Tonnage += actualTonnage;
        totalSummary.Actual_Grade += actualGrade * actualTonnage;
        totalSummary.Actual_Content += actualKgs;
        totalSummary.Mined_Tonnage_Sum += actualTonnage;

        totalSummary.Tramming_Budget_Tonnage += trammingBudgetTonnage;
        totalSummary.Tramming_Budget_Grade += trammingBudgetGrade * trammingBudgetTonnage;
        totalSummary.Tramming_Budget_Content += trammingBudgetKgs;
        totalSummary.Tramming_Budget_Tonnage_Sum += trammingBudgetTonnage;

        totalSummary.Tramming_Actual_Tonnage += trammingActualTonnage;
        totalSummary.Tramming_Actual_Grade += trammingActualGrade * trammingActualTonnage;
        totalSummary.Tramming_Actual_Content += trammingActualKgs;
        totalSummary.Tramming_Actual_Tonnage_Sum += trammingActualTonnage;
      });

      // Calculate weighted averages
      totalSummary.FY2025_Plan_Grade = totalSummary.FY2025_Plan_Tonnage_Sum > 0 ? totalSummary.FY2025_Plan_Grade / totalSummary.FY2025_Plan_Tonnage_Sum : 0;
      totalSummary.Planned_Grade = totalSummary.Planned_Tonnage_Sum > 0 ? totalSummary.Planned_Grade / totalSummary.Planned_Tonnage_Sum : 0;
      totalSummary.Actual_Grade = totalSummary.Mined_Tonnage_Sum > 0 ? totalSummary.Actual_Grade / totalSummary.Mined_Tonnage_Sum : 0;
      totalSummary.Tramming_Budget_Grade = totalSummary.Tramming_Budget_Tonnage_Sum > 0 ? totalSummary.Tramming_Budget_Grade / totalSummary.Tramming_Budget_Tonnage_Sum : 0;
      totalSummary.Tramming_Actual_Grade = totalSummary.Tramming_Actual_Tonnage_Sum > 0 ? totalSummary.Tramming_Actual_Grade / totalSummary.Tramming_Actual_Tonnage_Sum : 0;

      const summaryData = Object.keys(summary).map(key => ({
        [summary_field]: key,
        FY2025_Plan_Tonnage: summary[key].FY2025_Plan_Tonnage,
        Planned_Tonnage: summary[key].Planned_Tonnage,
        Mined_Tonnage: summary[key].Mined_Tonnage,
        Tramming_Budget_Tonnage: summary[key].Tramming_Budget_Tonnage,
        Tramming_Actual_Tonnage: summary[key].Tramming_Actual_Tonnage,
        FY2025_Plan_Grade: summary[key].FY2025_Plan_Tonnage_Sum > 0 ? Number((summary[key].FY2025_Plan_Grade / summary[key].FY2025_Plan_Tonnage_Sum).toFixed(2)) : 0,
        Planned_Grade: summary[key].Planned_Tonnage_Sum > 0 ? Number((summary[key].Planned_Grade / summary[key].Planned_Tonnage_Sum).toFixed(2)) : 0,
        Actual_Grade: summary[key].Mined_Tonnage_Sum > 0 ? Number((summary[key].Actual_Grade / summary[key].Mined_Tonnage_Sum).toFixed(2)) : 0,
        Tramming_Budget_Grade: summary[key].Tramming_Budget_Tonnage_Sum > 0 ? Number((summary[key].Tramming_Budget_Grade / summary[key].Tramming_Budget_Tonnage_Sum).toFixed(2)) : 0,
        Tramming_Actual_Grade: summary[key].Tramming_Actual_Tonnage_Sum > 0 ? Number((summary[key].Tramming_Actual_Grade / summary[key].Tramming_Actual_Tonnage_Sum).toFixed(2)) : 0,
        FY2025_Plan_Content: summary[key].FY2025_Plan_Content,
        Planned_Content: summary[key].Planned_Content,
        Actual_Content: summary[key].Actual_Content,
        Tramming_Budget_Content: summary[key].Tramming_Budget_Content,
        Tramming_Actual_Content: summary[key].Tramming_Actual_Content
      }));

      setAllData(totalSummary)
      setData(summaryData);

      console.log(summaryData)
    
  }, [stopeID, summary_field,stopeData,parsedData]);

  return (
    <div className="relative w-full h-full bg-white z-10">
      {!stopeID && <Card parsedData={parsedData} setStopeData={setStopeData}/> }
      <select
        value={summary_field}
        onChange={(e) => setSummaryField(e.target.value)}
        className="p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 m-4"
      >
        <option value="Month">Month</option>
        <option value="Quarter">Quarter</option>
        <option value="Year">Year</option>
      </select>

      {/* Summary Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <h3 className="text-sm font-semibold text-gray-700 mb-2 p-3 border-b border-gray-200">Summary Statistics</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 border border-gray-200 text-xs">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-r border-gray-200">Metric</th>
                <th className="px-2 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r border-gray-200">FY2025</th>
                <th className="px-2 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r border-gray-200">Stoping Budget</th>
                <th className="px-2 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r border-gray-200">Stoping Actual</th>
                <th className="px-2 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-r border-gray-200">Tramming Budget</th>
                <th className="px-2 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Tramming Actual</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              <tr className="hover:bg-gray-50">
                <td className="px-2 py-1 whitespace-nowrap text-xs font-medium text-gray-900 border-r border-gray-200">Tonnage</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.FY2025_Plan_Tonnage).toLocaleString("en-EN", { maximumFractionDigits: 0 })} t</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.Planned_Tonnage).toLocaleString("en-EN", { maximumFractionDigits: 0 })} t</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.Mined_Tonnage).toLocaleString("en-EN", { maximumFractionDigits: 0 })} t</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.Tramming_Budget_Tonnage).toLocaleString("en-EN", { maximumFractionDigits: 0 })} t</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center">{Number(alldata.Tramming_Actual_Tonnage).toLocaleString("en-EN", { maximumFractionDigits: 0 })} t</td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="px-2 py-1 whitespace-nowrap text-xs font-medium text-gray-900 border-r border-gray-200">Grade</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.FY2025_Plan_Grade).toFixed(2)} g/t</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.Planned_Grade).toFixed(2)} g/t</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.Actual_Grade).toFixed(2)} g/t</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.Tramming_Budget_Grade).toFixed(2)} g/t</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center">{Number(alldata.Tramming_Actual_Grade).toFixed(2)} g/t</td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="px-2 py-1 whitespace-nowrap text-xs font-medium text-gray-900 border-r border-gray-200">Content</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.FY2025_Plan_Content).toLocaleString("en-EN", { maximumFractionDigits: 1 })} kg</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.Planned_Content).toLocaleString("en-EN", { maximumFractionDigits: 1 })} kg</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.Actual_Content).toLocaleString("en-EN", { maximumFractionDigits: 1 })} kg</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center border-r border-gray-200">{Number(alldata.Tramming_Budget_Content).toLocaleString("en-EN", { maximumFractionDigits: 1 })} kg</td>
                <td className="px-2 py-1 whitespace-nowrap text-xs text-gray-900 text-center">{Number(alldata.Tramming_Actual_Content).toLocaleString("en-EN", { maximumFractionDigits: 1 })} kg</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

             <GridItem title="Broken Tonnes Trend" key={1}>

              
         <SummaryChart
           stopeID={stopeID}
           summary_field={summary_field}
           data={data}
           target_fields={
             [
               { column_name: 'FY2025_Breaking_Plan_t', legend_name: 'FY2025' , graphKey:'FY2025_Plan_Tonnage' },
               { column_name: 'Stoping_Budget_t', legend_name: 'Stoping Budget' , graphKey:'Planned_Tonnage' },
               { column_name: 'Stoping_Actual_t', legend_name: 'Stoping Actual', graphKey:'Mined_Tonnage'  },
               { column_name: 'Tramming_Budget_t', legend_name: 'Tramming Budget', graphKey:'Tramming_Budget_Tonnage'  },
               { column_name: 'Tramming_Actual_t', legend_name: 'Tramming Actual', graphKey:'Tramming_Actual_Tonnage'  }
             ]
           }
           graphOptions={{
             graph_type: 'BarChart', // Example graph type
             graph_title: 'Ore Source Reconciliation',
             x_title: 'Month',
             y_title: 'Tonnage (t)'
           }}
         />
       </GridItem>  

       <GridItem title="Grade Trend"  key={2}>
         <SummaryChart
           stopeID={stopeID}
           summary_field={summary_field}
           data={data}
           target_fields={
             [
               { column_name: 'FY2025_Breaking_Plan_gpt', legend_name: 'FY2025' , graphKey:'FY2025_Plan_Grade' },
               { column_name: 'Stoping_Budget_gpt', legend_name: 'Stoping Budget' , graphKey:'Planned_Grade' },
               { column_name: 'Stoping_Actual_gpt', legend_name: 'Stoping Actual', graphKey:'Actual_Grade'  },
               { column_name: 'Tramming_Budget_gpt', legend_name: 'Tramming Budget', graphKey:'Tramming_Budget_Grade'  },
               { column_name: 'Tramming_Actual_gpt', legend_name: 'Tramming Actual', graphKey:'Tramming_Actual_Grade'  }
             ]
           }
           graphOptions={{
             graph_type: 'BarChart', // Example graph type
             graph_title: 'Ore Source Reconciliation',
             x_title: 'Month',
             y_title: 'Grade (g/t)'
           }}
         />
       </GridItem> 

       <GridItem title="Content Trend" key={3}>
         <SummaryChart
           stopeID={stopeID}
           summary_field={summary_field}
           data={data}
           target_fields={
             [
               { column_name: 'FY2025_Breaking_Plan_kgs', legend_name: 'FY2025' , graphKey:'FY2025_Plan_Content' },
               { column_name: 'Stoping_Budget_kgs', legend_name: 'Stoping Budget' , graphKey:'Planned_Content' },
               { column_name: 'Stoping_Actual_kgs', legend_name: 'Stoping Actual', graphKey:'Actual_Content'  },
               { column_name: 'Tramming_Budget_kgs', legend_name: 'Tramming Budget', graphKey:'Tramming_Budget_Content'  },
               { column_name: 'Tramming_Actual_kgs', legend_name: 'Tramming Actual', graphKey:'Tramming_Actual_Content'  }
             ]
           }
           graphOptions={{
             graph_type: 'BarChart', // Example graph type
             graph_title: 'Ore Source Reconciliation',
             x_title: 'Month',
             y_title: 'Gold (kg)'
           }}
         />
       </GridItem>    
      
    </div>
  );
};

export default StopeChart;

const SummaryChart = ({ data, summary_field, target_fields, graphOptions })=>{
  console.log('SummaryChart data:', data);
  console.log('SummaryChart target_fields:', target_fields);
  
  if (!data || Object.keys(data).length === 0) {
    return (
      <div className="flex items-center justify-center h-full text-white">
        <p>No data available</p>
      </div>
    );
  }

  return(
    <ResponsiveContainer width="100%" height={300} className="relative z-20">
    <BarChart
      width={500}
      height={500}
      data={Object.values(data)}
      margin={{
        top: 20,
        right: 10,
        bottom: 20,
      }}
    >
      <CartesianGrid strokeDasharray="5 5" />
      <XAxis dataKey={summary_field}  fontSize={10}  tick={{ fill: 'white' }} label={{ value: summary_field, position: 'insideBottomRight', offset: 0 }} />
      <YAxis  fontSize={10}  tick={{ fill: 'white' }} tickFormatter={graphOptions.y_title.includes('Grade') ? (v) => v.toFixed(2) : (v) => v.toLocaleString()} label={{ value: graphOptions.y_title, angle: -90, position: 'insideLeft' }} />      
      <Tooltip content={CustomTooltip} />
      <Legend fontSize={8} />
    
      {target_fields.map((field,index) => (
        <Bar key={field.graphKey} dataKey={field.graphKey} fill={colors[index]} name={field.legend_name}/>
      ))} 
    </BarChart>
    </ResponsiveContainer>
  )
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    //console.log(payload)
    return (
      <div className="p-4 bg-slate-900 flex flex-col gap-4 rounded-md">
        <p className="text-medium text-lg text-white">{` ${''+label}`}</p>
        {
          payload.map((item,index)=>{
            return(
            <p className="text-sm text-blue-400" key={index}>
              {item.name}:
            <span className="sm-2">{ Number(item.value).toLocaleString("en-EN", { maximumFractionDigits: item.name.endsWith('Grade')?2:2 })}</span>
            </p>
            )
          })
        }
        
        
      </div>
    );
  }

  return null;
};

function GridItem({title,children}){
  return(
      <div className='flex flex-col items-center justify-center border border-slate-500 bg-stone-800 min-h-96 h-96 rounded-md shadow-lg mt-4'>
          <h3 className='text-xl font-semibold text-white mb-1'>{title}</h3>
          <div className='w-full h-80 flex-1'>
            {children}
          </div>
      </div>
  )
}

function GridItem1({title,value,prefix,children,variance}){
  const isVariance = variance !== undefined;
  const isPositive = isVariance && variance > 0;
  const isNegative = isVariance && variance < 0;
  
  const getBackgroundStyle = () => {
    if (!isVariance) return {};
    
    if (isPositive) {
      return {
        background: `linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(34, 197, 94, 0.05) 100%)`,
        position: 'relative',
        overflow: 'hidden'
      };
    } else if (isNegative) {
      return {
        background: `linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%)`,
        position: 'relative',
        overflow: 'hidden'
      };
    }
    return {};
  };

  const getArrowIcon = () => {
    if (!isVariance) return null;
    
    if (isPositive) {
      return (
        <div className="absolute inset-0 flex items-center justify-center opacity-10">
          <svg width="160" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L12 20M12 4L6 10M12 4L18 10" stroke="rgb(34, 197, 94)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      );
    } else if (isNegative) {
      return (
        <div className="absolute inset-0 flex items-center justify-center opacity-10">
          <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 20L12 4M12 20L6 14M12 20L18 14" stroke="rgb(239, 68, 68)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      );
    }
    return null;
  };

  const getTextColor = () => {
    if (!isVariance) return 'text-orange-600';
    if (isPositive) return 'text-green-600';
    if (isNegative) return 'text-red-600';
    return 'text-orange-600';
  };

  return(
      <div 
          className='flex flex-col items-center justify-center border h-[100px] rounded overflow-hidden shadow-lg relative' 
          style={getBackgroundStyle()}
      >
          {getArrowIcon()}
          <h3 className='text-sm font-semibold text-green-800 mb-1 relative z-10'>{title}</h3>
          <h3 className={`text-sm font-semibold mb-1 relative z-10 ${getTextColor()}`}>
              {value} <span className='text-md font-semibold text-orange-300'>{prefix}</span>
          </h3>
          {children}
      </div>
  )
}


const Card = ({ parsedData,setStopeData}) => {

  const [selectedLevels, setSelectedLevels] = useState(['1L', '2L', '3L', '4L', '5L', '6L']);
  const [period, setPeriod] = useState('Month');
  const [selectedPeriod , setSelectedPeriod] = useState([])
  const [selectPeriodOptions , setSelectPeriodOptions] = useState([])

  

  

  const levels = ['1L', '2L', '3L', '4L', '5L', '6L'];
  const periods = ['Month', 'Quarter', 'Year'];

  const handlePeriodChange = (e) => {
    setPeriod(e.target.value);
  };

  useEffect(()=>{
    console.log(selectedLevels,period,selectedPeriod)
    setStopeData([selectedLevels,period,selectedPeriod])
  },[selectedLevels,period,selectedPeriod])

  useEffect(()=>{
    
    if(!parsedData) return
    if(!parsedData.length>0) return
    setSelectedPeriod([])
    
    // Add Month, Quarter, Year fields to parsedData for filtering
    const processedData = parsedData.map(row => {
      const dateStr = row.Date;
      let date = null;
      
      if (dateStr) {
        const parts = dateStr.split('/');
        if (parts.length === 3) {
          const day = parseInt(parts[0]);
          const month = parseInt(parts[1]) - 1;
          const year = parseInt(parts[2]);
          date = new Date(year, month, day);
        }
      }

      return {
        ...row,
        Month: date ? date.toLocaleString('default', { month: 'long' }) + ' ' + date.getFullYear() : '',
        Quarter: date ? `Q${Math.floor((date.getMonth() + 3) / 3)} ${date.getFullYear()}` : '',
        Year: date ? date.getFullYear().toString() : ''
      };
    });
    
    console.log([...new Set(processedData.map((item) => item[period]))])
    setSelectPeriodOptions([...new Set(processedData.map((item) => item[period]))])
  },[period, parsedData])


  if(!parsedData) return
  if(!parsedData.length>0) return

  const itemClickedPeriod = (item) => {
    setSelectedPeriod((prevSelected) => 
      prevSelected.includes(item) 
        ? prevSelected.filter((i) => i !== item) 
        : [...prevSelected, item]
    );
  };

  const itemClickedLevel = (item) => {
    setSelectedLevels((prevSelected) => 
      prevSelected.includes(item) 
        ? prevSelected.filter((i) => i !== item) 
        : [...prevSelected, item]
    );
  };

  return (
    <div className="p-4 bg-white shadow rounded">
      <div className='mb-4 mt-1 block w-full'>
        <MultiSelectDropdown label={'LEVEL'} list={levels} selectedlist={selectedLevels} itemClick={itemClickedLevel} />
      </div>
      <div className="mb-4  mt-1 block w-full">
        <div className='cursor-pointer border-solid p-4 border-stone-500 shadow-lg w-full border'>
          {/* <label className="block text-gray-700">Period</label> */}
          <select value={period} onChange={handlePeriodChange} className="mt-1 block w-full">
            {periods.map((prd) => (
              <option key={prd} value={prd}>
                {prd}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className='mb-4 mt-1 block w-full'>
        <MultiSelectDropdown label={'Options'} list={selectPeriodOptions} selectedlist={selectedPeriod} itemClick={itemClickedPeriod} />
      </div>

    </div>
  );
};

